import { parse } from '../../util/urlHelpers';
import { storableError } from '../../util/errors';
import { getAdminAbandonedCarts } from '../../util/api';

export const FETCH_ABANDONED_CARTS_REQUEST = 'app/AdminAbandonedCartsPage/FETCH_ABANDONED_CARTS_REQUEST';
export const FETCH_ABANDONED_CARTS_SUCCESS = 'app/AdminAbandonedCartsPage/FETCH_ABANDONED_CARTS_SUCCESS';
export const FETCH_ABANDONED_CARTS_ERROR = 'app/AdminAbandonedCartsPage/FETCH_ABANDONED_CARTS_ERROR';

const initialState = {
  fetchInProgress: false,
  fetchError: null,
  pagination: null,
  stats: null,
  carts: [],
};

export default function adminAbandonedCartsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ABANDONED_CARTS_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_ABANDONED_CARTS_SUCCESS:
      return {
        ...state,
        fetchInProgress: false,
        carts: payload.data || [],
        pagination: payload.meta || null,
        stats: payload.meta?.stats || null,
      };
    case FETCH_ABANDONED_CARTS_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    default:
      return state;
  }
}

const fetchRequest = () => ({ type: FETCH_ABANDONED_CARTS_REQUEST });
const fetchSuccess = response => ({ type: FETCH_ABANDONED_CARTS_SUCCESS, payload: response });
const fetchError = e => ({ type: FETCH_ABANDONED_CARTS_ERROR, error: true, payload: e });

const PAGE_SIZE = 50;

const normalizeDateParam = (value, endOfDay = false) => {
  if (!value) return undefined;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return endOfDay ? `${value}T23:59:59.999Z` : `${value}T00:00:00.000Z`;
  }
  return value;
};

export const loadData = (params, search) => dispatch => {
  dispatch(fetchRequest());

  const { page = 1, since, until, registeredOnly } = parse(search) || {};

  return getAdminAbandonedCarts({
    page,
    perPage: PAGE_SIZE,
    since: normalizeDateParam(since, false),
    until: normalizeDateParam(until, true),
    registeredOnly: registeredOnly === 'true',
  })
    .then(response => {
      dispatch(fetchSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(fetchError(storableError(e)));
      throw e;
    });
};
